<template>
  <AwBadge :color="color">
    <span>{{ translateBusinessLifecycleStage.fr[status] }}</span>
  </AwBadge>
</template>

<script setup lang="ts">
import type { Color } from "@asap/design/styles/colors";
import type { BusinessLifecycleStage } from "@asap/shared/types/supabase.types.gen";
import { translateBusinessLifecycleStage } from "@asap/shared/utils/translate";
type Props = {
  status: BusinessLifecycleStage;
};

const props = defineProps<Props>();

const color = computed<Color>(() => {
  if (props.status === "prospect") {
    return "blue";
  }
  if (props.status === "lead") {
    return "critical";
  }
  return "success";
});
</script>
